
//	Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import clsx from 'clsx';

// Styles
import styles from './link.module.scss';


//
//	RAYC / UI / Components / Link
//


function getIsActive( activeHref, href ) {
	return activeHref === href;
}


export default function Link( props ) {
	const router = useRouter();
	const {
		children, className = '',
		href, element = 'a', type = 'button', ariaLabel,
		disabled, external = false,
		activeClass = '-is-active', activeClassFn = getIsActive,
		onClick,
		...restProps
	} = props;

	const elemenType = href ? 'a' : element;

	const _isAnchor = elemenType === 'a';
	const _isButton = elemenType === 'button';
	const _isRoutable = ( typeof href !== 'undefined' );
	const _isActive = activeClassFn( router.asPath, href );

	let elProps = {
		...restProps,
		children,
		'className': clsx( className, {
			[ styles[ 'c-link' ]]: !className.includes( 'c-button' ),
			[ activeClass ]: _isActive,
			'-is-disabled': disabled,
		}),
		...ariaLabel && { 'aria-label': ariaLabel },
		onClick: e => {
			if ( disabled ) return e.preventDefault();
			if ( onClick ) onClick( e );
		},
	};

	if ( _isButton ) {
		elProps = {
			...elProps,
			type,
			disabled,
		};
	}

	if ( _isAnchor && external ) {
		elProps.href = href;
		elProps.target = '_blank';
		elProps.rel = 'external nofollow noreferrer noopener';
	}

	const linkContent = React.createElement( elemenType, elProps );

	if ( !external && _isRoutable ) {
		return (
			<NextLink href={ href }>
				{ linkContent }
			</NextLink>
		);
	}

	return linkContent;
}

Link.propTypes = {
	children: PropTypes.node,
	element: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.oneOf([ 'a', 'button', 'span' ]),
	]),
	type: PropTypes.oneOf([ 'button', 'submit' ]),
	className: PropTypes.string,
	href: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
	as: PropTypes.string,
	external: PropTypes.bool,
	disabled: PropTypes.bool,
	focusable: PropTypes.bool,
	onClick: PropTypes.func,
	ariaLabel: PropTypes.string,
};
